import { IconType } from '@/lib/enum/Icon';
import { RequireAtLeastOne } from '@/lib/helpers/types';
import { redirect } from '@/router/router';
import { Location } from 'vue-router';

export const ALL_ITEMS_ID = -1 as const;

export type ActionItem<T = unknown> = RequireAtLeastOne<
  {
    id?: string | number;
    name?: string;
    description?: string;
    stat?: string | number;
    icon?: IconType | string;
    action?: (item: ActionItem<T>) => void | Promise<void>;
    to?: Location;
    disabled?: boolean;
    hidden?: boolean;
    dividerTop?: boolean;
    data?: T;
  },
  'name' | 'id'
>;

export const isActionItemClickable = (actionItem: ActionItem): boolean =>
  (actionItem.action || actionItem.to) &&
  !actionItem.disabled &&
  !actionItem.hidden;

export const actActionItem = (actionItem: ActionItem): void => {
  if (!isActionItemClickable(actionItem)) return;
  if (actionItem.action) actionItem.action(actionItem);
  if (actionItem.to) redirect(actionItem.to);
};
